// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/bg.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container {
  min-height: 100vh;
  padding-top: 80px;
}
.head-bar {
  border-radius: 10px;
  position: relative;
  height: 200px;
  margin-top: 20px;
  margin-bottom: 50px;
}
/* 伪元素作为模糊背景层 */
.head-bar::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  filter: blur(3px); /* ✅ 只对背景图片模糊 */
  z-index: 1;
}

.about-title {
  position: relative;
  z-index: 2; /* 高于伪元素 */
  text-align: center;
  font-size: 6.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  background: linear-gradient(165deg, #000 0%, #ffffff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.about-content {
  font-size: 5.5rem;
  line-height: 200px;
}

.about-title2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  background: linear-gradient(180deg, #ffffff 0%, #00a3ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Responsive Design */
@media (max-width: 768px) {
  .content-section {
    padding: 4rem 5%;
  }

  .section-header h2 {
    font-size: 2rem;
  }

  .card-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .tech-card {
    padding: 2rem;
  }
}

@media (max-width: 480px) {
  .section-header h2 {
    font-size: 1.6rem;
  }

  .tech-card h3 {
    font-size: 1.3rem;
  }

  .content-section {
    padding: 3rem 4%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/about/About.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;AACA,eAAe;AACf;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yDAAoD;EACpD,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB,EAAE,eAAe;EAClC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU,EAAE,UAAU;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,0DAA0D;EAC1D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".page-container {\n  min-height: 100vh;\n  padding-top: 80px;\n}\n.head-bar {\n  border-radius: 10px;\n  position: relative;\n  height: 200px;\n  margin-top: 20px;\n  margin-bottom: 50px;\n}\n/* 伪元素作为模糊背景层 */\n.head-bar::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: url(\"../../assets/images/bg.jpeg\");\n  background-size: cover;\n  background-position: center;\n  filter: blur(3px); /* ✅ 只对背景图片模糊 */\n  z-index: 1;\n}\n\n.about-title {\n  position: relative;\n  z-index: 2; /* 高于伪元素 */\n  text-align: center;\n  font-size: 6.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  background: linear-gradient(165deg, #000 0%, #ffffff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n.about-content {\n  font-size: 5.5rem;\n  line-height: 200px;\n}\n\n.about-title2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  background: linear-gradient(180deg, #ffffff 0%, #00a3ff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .content-section {\n    padding: 4rem 5%;\n  }\n\n  .section-header h2 {\n    font-size: 2rem;\n  }\n\n  .card-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .tech-card {\n    padding: 2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .section-header h2 {\n    font-size: 1.6rem;\n  }\n\n  .tech-card h3 {\n    font-size: 1.3rem;\n  }\n\n  .content-section {\n    padding: 3rem 4%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
